import wx from 'weixin-js-sdk'
import axios from 'axios'
import { Toast } from 'vant';
const wxApi={
    wxRegister (appId,url) {
        axios.post(ENV_API.API_HOST + '/proxy/v1/wechat/jsapiSign', {appId:appId,url:url}).then(function (res) {
            //console.log(res);
            // alert(url);
            // console.log(res);
            if (res.data.code == '00000') {
                var data=res.data.result;
                wx.config({
                    debug: false, // 开启调试模式
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature, // 必填，签名，见附录1
                    jsApiList:['onMenuShareTimeline','onMenuShareAppMessage','updateTimelineShareData','updateAppMessageShareData','startRecord','previewImage','chooseImage','uploadVoice','scanQRCode'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    openTagList:['wx-open-launch-weapp']
                });

                wx.ready(function(){
              
                    // wx.hideOptionMenu();
                    // 如果需要定制ready回调方法
                    // if (callback) {
                    //   callback()
                    // }
                })

                wx.error(function(res) {    
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，    
                    // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，   
                    //对于SPA可以在这里更新签名。    // 
                    // if(res.errMsg=='config:ok') return;
                    Toast(res.errMsg); 
                });
            }
        });
    },
      /**
  * [ShareTimeline 微信分享到朋友圈]
  * @param {[type]} option [分享信息]
  * @param {[type]} success [成功回调]
  * @param {[type]} error   [失败回调]
  */
    ShareTimeline (option) {
        wx.updateTimelineShareData({
            title: option.title, // 分享标题
            link: option.link, // 分享链接
            imgUrl: option.imgUrl, // 分享图标
            success () {
                // 用户成功分享后执行的回调函数
                option.success()
            },
            cancel () {
                // 用户取消分享后执行的回调函数
                option.error()
            }
        });
    },
    /*** 
     * [shareAppMessage 微信分享好友]
     ***/
   shareAppMessage(option){
        wx.updateAppMessageShareData({
            title: option.title, // 分享标题
            desc: option.myValue, // 分享描述
            link: option.link, // 分享链接
            imgUrl:option.imgs, // 分享图标
            success () {
                // 用户成功分享后执行的回调函数
                option.success()
            },
            cancel () {
                // 用户取消分享后执行的回调函数
                option.error()
            }
        })
    },
    //微信扫一扫
    wxScan(option){
        wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
                var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                // Toast(result);
              option.success(result);
            },
            cancel:()=>{
                Toast('失败')
            }
           
          });
    },
 
}
export default wxApi
